import CustomerBase from "./components/Base";

export default function CustomerFeature() {
  return (
    <div className="relative">
      <CustomerBase />
    </div>
  );
}
